<div class="dialog-container">
  <div class="dialog-icon">
    <i class="bi bi-person-dash"></i>
  </div>

  <h2 class="dialog-title">Are you sure?</h2>

  <p class="dialog-text">
    This action will remove the
    <b>{{
      data.type === usersRolesTeacher.CoTeacher ? "co-teacher" : "student"
    }}</b>
    from the classroom. Do you want to continue?
  </p>

  <div class="dialog-actions">
    <button class="btn-cancel" (click)="onCancel()">Cancel</button>
    <button class="btn-red" (click)="onRemove()">Remove</button>
  </div>
</div>